<template>
    <a-card>
        <a-form class="table-search" ref="searchForm" layout="inline" :model="searchForm">
            <a-form-item label="联系人" name="contacts">
                <a-input v-model:value="searchForm.contacts" placeholder="请输入联系人"/>
            </a-form-item>
            <a-form-item>
                <a-button type="primary" @click="onSearch">查询</a-button>
                <a-button @click="onReset">重置</a-button>
            </a-form-item>
        </a-form>
        <!-- <div class="table-toolbar">
            <a-button type="primary" @click="onAdd">
                <template #icon>
                    <plus-outlined/>
                </template>
                新增
            </a-button>
            <a-popconfirm title="确认要删除吗?" @confirm="onDeleteBatch(deleteUrl)" v-if="selectedRowKeys.length">
                <a-button danger>批量删除</a-button>
            </a-popconfirm>
        </div> -->
        <a-alert type="info" showIcon class="table-alert" v-if="selectedRowKeys.length">
            <template #message>
                已选择 {{ selectedRowKeys.length }} 项
                <a @click="onClearSelected" class="ml-20 float-right">清空</a>
            </template>
        </a-alert>
        <a-table
            :columns="columns"
            :pagination="pagination"
            :data-source="dataSource"
            :loading="loading"
            @change="onTableChange">
            <template #contacts="{record}">
                <a @click="onDetail(record.key)">{{record.contacts}}</a>
            </template>
            <template #action="{record}">
                <a @click="onDetail(record.key)">查看回复 </a>
                <a v-if="record.evaluate==null" @click="onScore(record.key)"> 评价</a>
                <!-- <div class="table-row-operations">
                    <a @click="onReply(record)">需求回复</a>
                </div> -->
            </template>
        </a-table>
    </a-card>
    <!-- <AddOrEditModal ref="modal" :form-primary-key-field="listKeyField" @finish="onFormEdited"/> -->
    <Detail ref="detail" @onCloseModel="onCloseModel"/>
	<scoreModal ref="scoremodal" :form-primary-key-field="listKeyField" @finish="onFormEdited"/>
    <!-- <replyModal ref="replymodal" :consultationId="consultationId"/> -->
</template>

<script>
// import replyModal from "./components/replyModal";
import Detail from "./components/Detail";
import scoreModal from "./components/scoreModal";
// import AddOrEditModal from "./components/AddOrEditModal";
import {tableListMixin} from "@/mixins";
import {financeConsultation} from "@/api/finance";

const columns = [
    // {title: "#", dataIndex: "index", key: "index", slots: {customRender: "index"}},
    {title: "联系人", dataIndex: "contacts", key: "contacts"},
    {title: "联系电话", dataIndex: "contactNumber", key: "contactNumber"},
    // {title: "咨询类型", dataIndex: "type", key: "type", slots: {customRender: "type"}},
    {title: "操作", dataIndex: "action", key: "action", slots: {customRender: "action"}},
];
export default {
    name: "融资需求",
    mixins: [ tableListMixin],
    components: {
        // AddOrEditModal,
        // replyModal, 
        Detail,
        scoreModal
    },
    data() {
        return {
            columns,
            queryParam: {sendId: this.$ls.get('notificationId') },
            listUrl: financeConsultation.pageList,
            listKeyField: "id",
            consultationId:'',
            deleteUrl: financeConsultation.remove
        }
    },
    methods: {
        onAdd() {
            this.onShowModal('modal');
        },
        onReply(id){
            this.consultationId = id.sendId
            this.onShowModal("replymodal")
        },
        onScore(id) {
                this.getAction({
                    url: financeConsultation.detail,
                    params: {id: id},
                    returnMsg: true,
                }).then(res => {
                        this.onShowModal('scoremodal', res.data);
                })
        },
        onDetail(id) {
            this.getAction({
                url: financeConsultation.detail,
                params: {id: id},
                returnMsg: true,
            }).then((res) => {
            this.onShowModal("detail", res.data || {consultationId: id});
            });
        },
        onEdit(record) {
            this.getAction({
                url: financeConsultation.detail,
                params: {id: record.id}
            }).then(res => {
                this.onShowModal('modal', res);
            })
        },
    }
}
</script>

<style scoped>

</style>
